import { all, fork } from 'redux-saga/effects'
import { watchGetMenus, watchGetMenusItems, watchGetCurrentMenuItems, watchGetMenusAndItems } from './menu'
import { watchDeviceLogin } from './user'
import { watchGetConfig, watchCreateConfig, watchUpdateConfig, watchRefreshConfigSaga } from './config'
import { watchRefundOrder, watchSyncRefunds } from './refund'
import { watchGetRevenueCenters } from './revenueCenter'
import {
  watchAddOrUpdateCartItemSaga,
  watchSafelyIncrementCartItemQuantitySaga,
  watchSafelyDecrementCartItemQuantitySaga,
  watchSafelyUpdateCartItemQuantitySaga,
  watchSafelyUpdateCartItemNotesSaga,
} from './cart'
import { watchGetCarouselImages } from './kiosk/carouselImages'
import {
  watchFetchCustomers,
  watchFetchCustomerPayments,
  watchFetchOrderingPreferences,
  watchFetchSalesEvents,
  watchFetchSalesEventTypes,
  watchCreateCustomerOrderPreference,
  watchFetchResourcesForOrderingPreferencesSaga,
} from './suites'

import { watchAdjustLineItemQuantities } from './orders/adjustments'
import { watchCombineOrders } from './orders/combine'
import { watchTransferOrder } from './orders/transfer'

import {
  watchGetPreOrders,
  watchReplayAuthStatus,
  watchSyncOrder,
  watchSyncOfflineOrder,
  watchSendOrderEmail,
  watchGetOrderDetails,
  watchGetOrdersDeltas,
} from './orders/order'

import {
  watchStartOfflineCardOrder,
  watchStartOnlineCardOrder,
} from './orders/cardOrder'

import { watchGetOrderTotalSaga, watchUpdateExemptionsSaga } from './orders/orderTotalRemote'

import {
  watchRichCheckoutOrderCompleted,
  watchSaveRichCheckoutOrder,
} from './orders/richCheckoutOrder'

import {
  watchStartTabOrderAdjustment,
  watchStartCloseTabOrder,
  watchStartCloseTabOrderWithCash,
  watchStartTabOrderAdjustmentAndClose,
} from './orders/tabOrder'

import {
  watchStartCashOrder,
} from './orders/cashOrder'

import {
  watchApplyOrderExemptionsSaga,
  watchStartRemotePaymentOrder,
  watchReopenOrderSaga,
  watchUpdateOrderLineItemsSaga,
  watchGetReceiptDetails,
} from './orders/suitesOrder'

import {
  watchStartNoOpTenderOrder,
  watchCloseTabWithNoOpTender,
} from './orders/noOpTender'

import {
  watchPrintOrder,
  watchFetchPrinters,
} from './printer'

import {
  watchAddPayment,
  watchAddTender,
  watchUpdatePayment,
} from './orders/addPayment'

import { watchFetchAttendantsSaga, watchAttemptPinLoginSaga, watchLogoutSaga } from './attendant'
import { watchSplitOrderSaga } from './orders/splitOrder'
import { watchFetchEmployeeRolesSaga } from './employeeRole'
import { watchPatchOrderSaga, watchUpdateUserNotesSaga } from './orders/patchOrder'
import { watchFetchPromotionsSaga } from './promotion'

function* watchAll() {
  yield all([
    fork(watchReplayAuthStatus),
    fork(watchStartCashOrder),
    fork(watchStartRemotePaymentOrder),
    fork(watchStartOfflineCardOrder),
    fork(watchStartOnlineCardOrder),
    fork(watchSyncOrder),
    fork(watchSyncOfflineOrder),
    fork(watchGetMenus),
    fork(watchGetMenusItems),
    fork(watchGetCurrentMenuItems),
    fork(watchDeviceLogin),
    fork(watchGetConfig),
    fork(watchCreateConfig),
    fork(watchUpdateConfig),
    fork(watchStartTabOrderAdjustment),
    fork(watchStartTabOrderAdjustmentAndClose),
    fork(watchStartCloseTabOrder),
    fork(watchStartCloseTabOrderWithCash),
    fork(watchRefundOrder),
    fork(watchSyncRefunds),
    fork(watchGetRevenueCenters),
    fork(watchGetPreOrders),
    fork(watchAddOrUpdateCartItemSaga),
    fork(watchSafelyIncrementCartItemQuantitySaga),
    fork(watchSafelyDecrementCartItemQuantitySaga),
    fork(watchSafelyUpdateCartItemQuantitySaga),
    fork(watchGetCarouselImages),
    fork(watchSaveRichCheckoutOrder),
    fork(watchSafelyUpdateCartItemNotesSaga),
    fork(watchFetchCustomers),
    fork(watchFetchCustomerPayments),
    fork(watchFetchOrderingPreferences),
    fork(watchFetchSalesEvents),
    fork(watchFetchSalesEventTypes),
    fork(watchUpdateExemptionsSaga),
    fork(watchGetOrderTotalSaga),
    fork(watchSendOrderEmail),
    fork(watchApplyOrderExemptionsSaga),
    fork(watchGetOrderDetails),
    fork(watchGetOrdersDeltas),
    fork(watchCreateCustomerOrderPreference),
    fork(watchFetchAttendantsSaga),
    fork(watchAttemptPinLoginSaga),
    fork(watchLogoutSaga),
    fork(watchReopenOrderSaga),
    fork(watchAdjustLineItemQuantities),
    fork(watchUpdateOrderLineItemsSaga),
    fork(watchSplitOrderSaga),
    fork(watchCombineOrders),
    fork(watchTransferOrder),
    fork(watchFetchEmployeeRolesSaga),
    fork(watchPrintOrder),
    fork(watchFetchPrinters),
    fork(watchGetReceiptDetails),
    fork(watchAddPayment),
    fork(watchAddTender),
    fork(watchUpdatePayment),
    fork(watchFetchResourcesForOrderingPreferencesSaga),
    fork(watchGetMenusAndItems),
    fork(watchRichCheckoutOrderCompleted),
    fork(watchPatchOrderSaga),
    fork(watchUpdateUserNotesSaga),
    fork(watchRefreshConfigSaga),
    fork(watchFetchPromotionsSaga),
    fork(watchStartNoOpTenderOrder),
    fork(watchCloseTabWithNoOpTender),
  ])
}

export default watchAll
